<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-30 17:32:55
 * @FilePath: /wemeet-admin-new/src/views/marketing/deliveryDetail.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <vab-query-form>
      <vab-query-form-left-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="群体名称">
            <el-input v-model.trim="queryForm.name" clearable placeholder="请输入群体名称" />
          </el-form-item>
          <el-form-item label="备注文字">
            <el-input v-model.trim="queryForm.remark" clearable placeholder="请输入备注文字" />
          </el-form-item>
          <el-form-item label="投放时间">
            <el-date-picker
              v-model="time"
              clearable
              end-placeholder="结束时间"
              range-separator="至"
              :shortcuts="shortcuts"
              start-placeholder="开始时间"
              type="datetimerange"
              @clear="clearDateTime"
            />
          </el-form-item>
          <el-form-item label="投放状态">
            <el-select
              v-model="queryForm.status"
              clearable
              filterable
              placeholder="请输入投放状态"
              style="margin-right: 10px"
            >
              <el-option
                v-for="(item, index) in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list">
      <el-table-column label="群体名称" prop="name" show-overflow-tooltip />
      <el-table-column label="备注" prop="remark" show-overflow-tooltip>
        <template #default="{ row }">
          <el-input v-if="row.showEdit" v-model="row.remark" @blur="saveRemark(row)" />
          <template v-else style="cursor: pointer">
            {{ row.remark ? row.remark : '暂无备注' }}
            <Edit style="width: 1em; height: 1em; margin-right: 8px" @click="row.showEdit = true" />
          </template>
        </template>
      </el-table-column>
      <el-table-column label="投放内容" prop="message" show-overflow-tooltip />
      <el-table-column label="投放时间" prop="createTime" show-overflow-tooltip />
      <el-table-column label="投放状态">
        <template #default="{ row }">
          <el-tag v-if="row.status == 'NOT_START'" type="info">未投放</el-tag>
          <el-tag v-if="row.status == 'ING'" type="success">投放中</el-tag>
          <el-tag v-if="row.status == 'PORTION_FAILED'" type="danger">部分失败</el-tag>
          <el-tag v-if="row.status == 'ALL_FAILED'" type="danger">全部失败</el-tag>
          <el-tag v-if="row.status == 'DONE'" type="success">已完成</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" show-overflow-tooltip width="420">
        <template #default="{ row }">
          <el-button plain type="info" @click="handleShare(row)">下载</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNumber"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />

    <sendMessageVue ref="sendMessageRef" />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { useRoute } from 'vue-router'
  import {
    getEnterpriseMarketingMessageHistory,
    getEnterpriseMarketingMessageHistoryUpdateRemark,
  } from '@/api/exhibitionManage'
  import VisitorImport from './components/visitorImport.vue'
  import sendMessageVue from './components/sendMessage.vue'
  import { parseTime } from '@/utils/index'
  export default defineComponent({
    name: 'Brand',
    components: {
      addGroup: defineAsyncComponent(() => import('./components/addGroup')),
      VisitorImport,
      sendMessageVue,
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          remark: '',
          pageNum: 1,
          pageSize: 10,
          name: '',
          endTime: '',
          startTime: '',
          status: '',
        },
        time: [],
        activeName: 'first',
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        upLoadRef: null,
        resultRef: null,
        addgroupDrawer: null,
        chooseVal: [],
        importRef: null,
        sendMessageRef: null,
        statusList: [
          {
            value: '',
            label: '全部',
          },
          // {
          //   value: 'NOT_START',
          //   label: '未投放',
          // },
          {
            value: 'ING',
            label: '投放中',
          },
          {
            value: 'PORTION_FAILED',
            label: '部分失败',
          },
          {
            value: 'ALL_FAILED',
            label: '全部失败',
          },
          {
            value: 'DONE',
            label: '已完成',
          },
        ],
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: row.exhibitorCode,
            industryType: row.industryType,
          },
        })
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.exhibitorCode) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        state.queryForm.pageNum = 1
        if (state.time && state.time.length > 0) {
          state.queryForm.startTime = state.time[0] ? parseTime(state.time[0], '{y}-{m}-{d} {h}:{i}:{s}') : ''
          state.queryForm.endTime = state.time[1] ? parseTime(state.time[1], '{y}-{m}-{d} {h}:{i}:{s}') : ''
        } else {
          state.queryForm.startTime = ''
          state.queryForm.endTime = ''
        }
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        const { data } = await getEnterpriseMarketingMessageHistory(state.queryForm)
        state.list = data && data.list ? data.list : []
        state.total = data && data.total ? data.total : 0
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      onActivated(() => {
        fetchData()
      })

      const addGroupFunc = () => {
        state.addgroupDrawer.handleOpen()
      }

      const handleSend = (row) => {
        state.sendMessageRef.handleOpen(row)
      }

      const handleSort = (row) => {
        state.editRef.showEdit(row)
      }
      const importBrand = () => {
        state.upLoadRef.showEdit()
      }
      const importProductBrand = () => {
        state.productUploadRef.showEdit()
      }
      const importResult = () => {
        state.resultRef.showEdit()
      }

      const handleShare = (row) => {
        if (row.fileUrl) {
          window.open(row.fileUrl)
        } else {
          proxy.$baseMessage(`当前无可下载文件`, 'error', 'vab-hey-message-error')
        }
      }

      const importData = () => {
        state.importRef.showEdit()
      }

      const saveRemark = async (row) => {
        console.log(row)
        try {
          let data = {
            id: row.id,
            remark: row.remark,
            pageNum: 0,
            pageSize: 100,
          }
          await getEnterpriseMarketingMessageHistoryUpdateRemark(data)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          fetchData()
        } catch (e) {
          console.log(e)
        }
      }

      return {
        ...toRefs(state),
        importData,
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        importProductBrand,
        handleConfig,
        Delete,
        Search,
        Plus,
        addGroupFunc,
        handleSort,
        handleSend,
        handleShare,
        importResult,
        importBrand,
        saveRemark,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
